import api from './api';

const transparencyService = {
  get: async (bcPaymentId) => {
    const params = bcPaymentId ? { bcPaymentId } : {};
    const response = await api.get('/transparency', { params });
    return response.data;
  },
};

export default transparencyService;
